module.exports = __webpack_public_path__ + "static/media/b7.7303fb7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangping/b7.mp3
// module id = b0/Y
// module chunks = 0